import { AnalyseViewTreeNode } from '../analyse';

export function isAnalyseViewTreeNode(data: any): data is AnalyseViewTreeNode {
  return (data as AnalyseViewTreeNode).id !== undefined;
}
